"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ACCOUNTS_PAYABLE", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ACCOUNTS_PAYABLE;
  }
});
Object.defineProperty(exports, "ACCOUNTS_RECEIVABLE", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ACCOUNTS_RECEIVABLE;
  }
});
Object.defineProperty(exports, "AUDIT_TRAIL", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.AUDIT_TRAIL;
  }
});
Object.defineProperty(exports, "BILLING_INVOICING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.BILLING_INVOICING;
  }
});
Object.defineProperty(exports, "BUDGETING_FORECASTING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.BUDGETING_FORECASTING;
  }
});
Object.defineProperty(exports, "CUSTOM_REPORTING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CUSTOM_REPORTING;
  }
});
Object.defineProperty(exports, "FUND_ACCOUNTING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.FUND_ACCOUNTING;
  }
});
Object.defineProperty(exports, "INTEGRATION_APIS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.INTEGRATION_APIS;
  }
});
Object.defineProperty(exports, "INVENTORY_REPORTING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.INVENTORY_REPORTING;
  }
});
Object.defineProperty(exports, "INVOICE_CUSTOMIZATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.INVOICE_CUSTOMIZATION;
  }
});
Object.defineProperty(exports, "JOURNAL_ENTRIES", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.JOURNAL_ENTRIES;
  }
});
Object.defineProperty(exports, "NONPROFITS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.NONPROFITS;
  }
});
Object.defineProperty(exports, "PAYMENT_PROCESSING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.PAYMENT_PROCESSING;
  }
});
Object.defineProperty(exports, "PURCHASE_ORDERS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.PURCHASE_ORDERS;
  }
});
Object.defineProperty(exports, "TAX_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.TAX_MANAGEMENT;
  }
});

var _CategoryFeature = require("../CategoryFeature");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/categoryFeatures/Accounting.js
// module id = 560
// module chunks = 209 210 211 212 213